import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  RegisteredUserLookup,
  RegisteredUserDetails,
} from './registered-user-lookup.model';

export interface GenerateRegisteredUserLookupOptions {
  readonly id: string;
  readonly emailUser?: RegisteredUserDetails;
  readonly phoneUser?: RegisteredUserDetails;
}

export function generateRegisteredUserLookupObject({
  id = String(generateId()),
  emailUser,
  phoneUser,
}: GenerateRegisteredUserLookupOptions): RegisteredUserLookup {
  return { id, emailUser, phoneUser };
}
